import { isServer, QueryClient } from '@tanstack/react-query';

interface QueryClientOptions {
  staleTime?: number;
}

function makeQueryClient({ staleTime = 60 * 1000 }: QueryClientOptions = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime,
        retry: 0,
      },
      mutations: {
        retry: 0,
        retryDelay: 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient(options?: QueryClientOptions) {
  if (isServer) {
    return makeQueryClient(options);
  }

  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient(options);
  }

  return browserQueryClient;
}
